export default {
  comexstats: {
    menuItem: "Comex Stat (exports)",
    pageTitle: "Comex Stat — Brazilian exports",
    subtitle:
      "Compare exactly two calendar years: pick both years below, then select country and NCM (click a search result). With calendar year mode, the monthly COMPARATIVO block is shown after both year tables.",
    countries: "Countries",
    countriesMultiselectPlaceholder: "Search or pick one or more countries",
    countriesMultiHint:
      "One or more countries: search in the box and click to add. Several countries use one combined MDIC request.",
    countriesSelectAll: "Select all",
    countriesRemoveAll: "Remove all",
    countriesEmptyMeansAll:
      "No country selected — the report will query every country in the loaded list (can be slow and a very large response).",
    country: "Country",
    countryPlaceholder: "Search country…",
    ncm: "Product (NCM)",
    ncmPlaceholder: "Search NCM or description…",
    productLabel: "Product name (shown in table)",
    productLabelPlaceholder: "Optional — defaults from NCM description",
    productLabelHint: "Text in the PRODUCT column; leave blank to use the selected NCM description.",
    years: "Years to compare (two only)",
    yearSelectFirst: "First year",
    yearSelectSecond: "Second year",
    yearsHint: "Choose two different years. Exactly two are loaded and compared.",
    yearsInvalid: "Choose two different years between 1997 and the current year.",
    filtersIncomplete: "Select a country.",
    loadingCountriesList: "Loading countries…",
    noCountriesLoaded: "Could not load the country list (ID below is still used if you run).",
    countriesListError: "Failed to load countries from Comex Stat.",
    countryIdFallback: "Country ID (if search does not work)",
    countryIdFallbackPlaceholder: "e.g. 676",
    countryIdFallbackHint:
      "Numeric ID from the MDIC country list. Use when autocomplete fails or after seeing a value in the network tab.",
    applyCountryId: "Apply",
    ncmCodeFallback: "NCM code (digits)",
    ncmCodeFallbackPlaceholder: "e.g. 12024200",
    ncmCodeFallbackHint: "Adds the product code without using search.",
    addNcmCode: "Add",
    countryIdInvalid: "Enter a valid country ID (positive number).",
    ncmCodeInvalid: "Enter an NCM with 4–8 digits.",
    hintNeedCountry: "Pick a country from the list.",
    hintNeedNcm: "Pick at least one NCM from the list or add a code below.",
    hintNeedYears: "Choose two different years.",
    monthComparisonTitle: "COMPARATIVO — calendar months",
    monthComparisonDeltaMt: "Δ MT destino (later − earlier)",
    monthComparisonDeltaShare: "COMPARATIVO",
    monthComparisonYoYDest: "YoY % MT destino",
    destinationMtExplain:
      "“MT destino (Comex)” is net-weight exports from Brazil to the selected country for the NCM (MDIC Comex Stat) — there is no API field named A-L TONS. If your spreadsheet column A-L TONS is built from contracts, manual entries, or another system, you still need to trace that source; we only show official Comex destination tons here.",
    msExplain:
      "MS is only the share column (%). Formula: MS = MT destino ÷ (“YYYY - MT”) × 100 — same row/month: destination tons divided by world NCM tons.",
    yearBasis: "Year definition",
    calendar: "Calendar (Jan–Dec)",
    cropMarch: "Crop year (Mar–Feb)",
    run: "Update report",
    loading: "Querying Comex Stat…",
    error: "Request failed",
    noResults: "No rows for this filter.",
    period: "PERIOD",
    product: "PRODUCT",
    officialMt: "MT destino (Comex)",
    yearWorldMt: "{year} - MT",
    msGlobal: "MS",
    comparisonTitle: "COMPARATIVO",
    comparisonYear: "YEAR",
    totalShippedShort: "MT destino",
    annualShareShort: "MS",
    yoyChange: "CHANGE",
    totalShippedFooter: "TOTAL SHIPPED {year}",
    generalStatsTitle: "Brazil — general statistics",
    generalStatsSubtitle:
      "World NCM exports (all destinations) by month — same series as the “YYYY - MT” column in the country table. One block per selected year.",
    generalStatsCardTitle: "{year}",
    includeApiDebugLabel:
      "After running with two countries, include a JSON debug block below (shape of MDIC response and parsed row counts) so you can copy it for support.",
    apiDebugCardTitle: "API debug (multi-country)",
    apiDebugCopy: "Copy JSON",
    apiNote:
      "Data loads in your browser from the public MDIC API. Closed calendar months are saved in your LawAI database (per tenant) so repeat reports skip redundant MDIC calls. You must be logged in for cache read/write. If it fails, wait a few seconds and click Update again.",
    exportExcel: "Export to Excel",
    exportExcelDone: "The spreadsheet was downloaded.",
    exportExcelError: "Could not generate the Excel file.",
    exportExcelNoRows: "There are no table rows to export.",
  },
};
